import { render, staticRenderFns } from "./AUserManagement.vue?vue&type=template&id=168fac3e&"
import script from "./AUserManagement.vue?vue&type=script&lang=ts&"
export * from "./AUserManagement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports